import { getLogInAsHeaders, LogInAsHeaderNames } from '@fusion/saas-components-v3'
import type {
  AveragePM,
  ChangeOverTime,
  CurrentReadings,
  ReadingMeasurement,
  StdTelemetry,
  TelemetryChartParams
} from '@/types/devices'
import { GET, GET_STREAM } from './helpers'

export const getLatest = function (devId: string) {
  return GET<StdTelemetry>(
    `/devices/${devId}/telemetry/latest`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

export const getLatestCurrentReadings = function (devId: string) {
  return GET<CurrentReadings>(
    `/devices/${devId}/current-readings/latest`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

export const getAverages = function (devId: string) {
  return GET<AveragePM>(
    `/devices/${devId}/telemetry/averages`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

export const getPercentChanged = function (devId: string) {
  return GET<ChangeOverTime>(
    `/devices/${devId}/telemetry/change-over-time`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

export const getGraphData = function (dataParams: TelemetryChartParams) {
  const { id, sensor, measurement, tempUnit, pressureUnit, pmUnit, start, end } = dataParams
  return GET<ReadingMeasurement>(
    `/devices/${id}/telemetry/chart?sensor=${sensor}&measurement=${measurement}&tempunit=${tempUnit}&pressureunit=${pressureUnit}&pmunit=${pmUnit}&start=${start}&end=${end}`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    undefined,
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

// getLatestTelemetryStream returns a DefaultReadableStream which will send the
// latest telemetry reading for a device with each chunk
export const getLatestTelemetryStream = function (devId: string) {
  return GET_STREAM<StdTelemetry>(
    `/devices/${devId}/telemetry/stream`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}

// getCurrentReadingsStream returns a DefaultReadableStream which will send the
// latest current readings view for a device with each chunk
export const getCurrentReadingsStream = function (devId: string) {
  return GET_STREAM<CurrentReadings>(
    `/devices/${devId}/current-readings/stream`,
    {
      ...getLogInAsHeaders([LogInAsHeaderNames.ACCOUNT_ID])
    },
    {},
    APP_ENV.VITE_APP_DEVICES_HOST_V3
  )
}
